import type { ItineraryItemDTO, PlaceDTO } from "./types.js";

type Bundleish = { items: ItineraryItemDTO[]; places: PlaceDTO[] };

const near = (p: PlaceDTO, lat: number | null, lng: number | null) =>
  lat != null && lng != null && Math.abs(p.lat - lat) < 5e-4 && Math.abs(p.lng - lng) < 5e-4;

/**
 * Где место используется в плане: дни пунктов с этим placeId, а также переезды, у которых
 * точка отправления/прибытия совпадает с координатами места (аэропорты, вокзалы).
 * Отменённые пункты не считаются.
 */
export function placeUsage(b: Bundleish) {
  const used = new Map<string, string[]>();
  const add = (id: string, day: string) => used.set(id, [...(used.get(id) ?? []), day]);
  for (const i of b.items) {
    if (i.status === "cancelled") continue;
    if (i.placeId) add(i.placeId, i.day);
    if (i.kind === "transport") for (const p of b.places) if (near(p, i.fromLat, i.fromLng) || near(p, i.toLat, i.toLng)) add(p.id, i.day);
  }
  return used;
}

/** Места, выпавшие из плана: статус «хотим», но ни один действующий пункт плана их не использует */
export function orphanPlaces(b: Bundleish, usage = placeUsage(b)) {
  return b.places.filter((p) => p.status === "want" && !usage.has(p.id));
}
